import React from "react";
import {
  Box,
  Flex,
  VStack,
  HStack,
  Text,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useColorModeValue,
  Container,
  Heading,
} from "@chakra-ui/react";

const ReferralsPage = () => {
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const acceptedInvites = [
    {
      email: "abc@gmail.com",
      dateOfReferral: "22nd Feb, 2024",
      inviteType: "Inside SME",
      role: "Management",
    },
    {
      email: "pqr@gmail.com",
      dateOfReferral: "22nd Feb, 2023",
      inviteType: "Outside SME",
      role: "CA/Advisor",
    },
  ];

  const pendingInvites = [
    {
      email: "abc@gmail.com",
      dateOfReferral: "22nd Feb, 2024",
      inviteType: "Inside SME",
      role: "Management",
    },
    {
      email: "pqr@gmail.com",
      dateOfReferral: "22nd Feb, 2023",
      inviteType: "Outside SME",
      role: "CA/Advisor",
    },
  ];

  const renderInvitesTable = (invites, tableTitle) => (
    <Box>
      <Flex>
        <Heading>{tableTitle}</Heading>
      </Flex>
      <TableContainer>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Email</Th>
              <Th>Date of Referral</Th>
              <Th>Invite Type</Th>
              <Th>Role</Th>
            </Tr>
          </Thead>
          <Tbody>
            {invites.map((invite, index) => (
              <Tr key={index}>
                <Td>{invite.email}</Td>
                <Td>{invite.dateOfReferral}</Td>
                <Td>{invite.inviteType}</Td>
                <Td>{invite.role}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );

    const transactionHistory = [
      {
        planName: "SME",
        billingDate: "22nd Feb, 2024",
        paymentMethod: "Debit Card",
        totalAmount: "60,000",
      },
      {
        planName: "SME",
        billingDate: "22nd Feb, 2023",
        paymentMethod: "Netbanking",
        totalAmount: "60,000",
      },
    ];

  return (
    <Box bg={bgColor} borderRadius="lg" boxShadow="md" p={6}>
      <Flex justifyContent="space-between" alignItems="center" mb={6}>
        <Heading size="lg">My Referrals</Heading>
        <Button>Invite People</Button>
      </Flex>

      <Flex
        justifyContent="center"
        alignItems="center"
        mt={1}
        p={1}
        className="bg-blue-50 rounded-lg"
      >
        <Text mr={2}>
          20 credits have been awarded to you for accepted invitations
        </Text>
        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clipRule="evenodd"
          />
        </svg> */}
      </Flex>
      <Box bg={bgColor} borderRadius="lg" boxShadow="md" p={6}>
        <Heading size="md" mb={6}>
          ACCEPTED INVITES
        </Heading>
        <TableContainer>
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>Email</Th>
                <Th>Date of Referral</Th>
                <Th>Invite Type</Th>
                <Th>Role</Th>
              </Tr>
            </Thead>
            <Tbody>
              {acceptedInvites.map((invite, index) => (
                <Tr key={index}>
                  <Td>{invite.email}</Td>
                  <Td>{invite.dateOfReferral}</Td>
                  <Td>{invite.inviteType}</Td>
                  <Td>{invite.role}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
      <Box bg={bgColor} borderRadius="lg" boxShadow="md" p={6}>
        <Heading size="md" mb={6}>
          PENDING INVITES
        </Heading>
        <TableContainer>
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>Email</Th>
                <Th>Date of Referral</Th>
                <Th>Invite Type</Th>
                <Th>Role</Th>
              </Tr>
            </Thead>
            <Tbody>
              {pendingInvites.map((invite, index) => (
                <Tr key={index}>
                  <Td>{invite.email}</Td>
                  <Td>{invite.dateOfReferral}</Td>
                  <Td>{invite.inviteType}</Td>
                  <Td>{invite.role}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default ReferralsPage;
